import { useEffect, useSyncExternalStore } from "react";

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · QwikSupport` : "QwikSupport";
    return () => {
      document.title = previous;
    };
  }, [title]);
}

/** Deterministic hue for an id, so each knowledge base keeps its colour. */
export function hueFor(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return hash % 360;
}

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

function subscribeReducedMotion(onChange: () => void): () => void {
  const media = window.matchMedia?.(REDUCED_MOTION);
  if (!media?.addEventListener) return () => {};
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

const prefersReducedMotion = () => window.matchMedia?.(REDUCED_MOTION)?.matches ?? false;

/** Whether the viewer asked for less motion; follows the setting while the page is open. */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(subscribeReducedMotion, prefersReducedMotion, () => false);
}
